module.exports = __webpack_public_path__ + "static/media/56-iveco-mercedes.241afd90.jpg";